import { load } from "@cashfreepayments/cashfree-js";
import { cashfreeMode } from "../config";
export const cashfree = await load({
  mode: cashfreeMode, //or production
});
